import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import { PredefinedTextLogger } from '@/entities/models/Annotation';
let ReturnFromDepartmentModal = class ReturnFromDepartmentModal extends Vue {
    constructor() {
        super(...arguments);
        this.unassignLogger = true;
        this.createAnnotation = true;
        this.customAnnotationText = '';
        this.PredefinedTextLogger = PredefinedTextLogger;
        this.annotationTexts = [PredefinedTextLogger.OWN, PredefinedTextLogger.UNASSIGN];
        this.predefinedAnnotationText = PredefinedTextLogger.UNASSIGN;
    }
    get isMobileView() {
        return window.innerWidth <= 768;
    }
    resultRetrieved() {
        this.$emit('modalClosed');
    }
    async returnLogger() {
        let annotationText;
        if (this.unassignLogger && this.createAnnotation) {
            annotationText =
                this.predefinedAnnotationText === PredefinedTextLogger.OWN
                    ? this.customAnnotationText
                    : this.$t(`component.report.create_annotation.predefined.${this.predefinedAnnotationText}`).toString();
        }
        else
            annotationText = null;
        let dto = {
            UnassignFromSource: this.unassignLogger,
            UnassignAnnotation: annotationText
        };
        this.$emit('returnLogger', dto);
    }
};
__decorate([
    Prop({ type: Object })
], ReturnFromDepartmentModal.prototype, "logger", void 0);
ReturnFromDepartmentModal = __decorate([
    Component
], ReturnFromDepartmentModal);
export default ReturnFromDepartmentModal;
